/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './toast';
import * as marketService from '../../services/marketService'
import * as userService from '../../services/userService'
import Autocomplete from 'react-autocomplete';
import { BASE_IMAGE_PATH } from '../../configs/api';
import MPModel from '../sub_components/masterPasswordModel'
import * as gameControlService from '../../services/gameControlService'

import * as _ from 'lodash';
class MarketBetLock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showToast: false,
            toastMsg: "",
            toastType: "",
            currentUser: "",
            master_password: "",
            user_list: [],
            user_list_search: [],
            lockUsers: [],
            lockUsersState: {},
            userState: {},
            userStateSearch: [],
            usersList: [],
            select_user_id: "",
            accounts: "",
            allChecked: false,
            downlineSearch: false,
            searchinList: "",
            openPopup: true,
            mpassword: ""
        };
    }
    async componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        let user_list = await userService.getUsers()
        user_list = user_list.items
        this.setState({ user_list: user_list, user_list_search: user_list, accounts: userData.sub })
        this.getUserMarketLock()
    }

    async getUserMarketLock() {
        let lockUsers = await marketService.getUserMarketLock(this.props.event_id, !!this.props.market.marketType ? this.props.market.marketType : this.props.market.mkt)
        let userState = {}
        for (let usr of this.state.user_list) {
            userState[usr.username] = false
        }
        for (let lckusr of lockUsers) {
            userState[lckusr.username] = true
        }

        this.setState({ userState: {}, lockUsers: [] },
            () => {
                this.setState({ userState: userState, lockUsers: lockUsers })
            }
        )
    }

    async onUserMarketLock() {

        if (this.state.mpassword === "") {
            this.props.notify(" Master Password is Required!", "error");
            this.setState({ openPopup: true })
            return false
        }

        let lockUser = []
        let unlockUser = []
        let lockUsersState = this.state.lockUsersState

        for (const [username, value] of Object.entries(lockUsersState)) {
            if (value) {
                lockUser.push(username)
            } else {
                unlockUser.push(username)
            }
        }

        let body = {
            "eventId": this.props.event_id,
            "marketType": !!this.props.market.marketType ? this.props.market.marketType : this.props.market.mkt,
            "lockingUsers": lockUser,
            "unlockingUsers": unlockUser,
            "masterPassword": this.state.master_password
        }
        body = this.clean(body)

        await marketService.addUserMarketLock(body).then((res) => {
            if (res.isSuccess) {
                this.props.notify(" Successfully Updated... ", "success");
                this.setState({ master_password: "", lockUsersState: {} })
                this.getUserMarketLock()
            }
            else {
                this.props.notify(res.exception.message, "error");
            }
        })
    }


    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }

    async onUserSearch(e, name, value) {
        if (value.length > 1) {
            this.setState({ [name]: value })
            let res = await userService.getUserSearchDetail(this.state.accounts, value)
            let lst = []
            for (let x of res.usersList) {
                lst.push({ label: x, value: x, title: x, name: x })
            }
            lst.sort(function(a, b) {
                if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
                if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
                return 0;
            });
            this.setState({ usersList: lst, userStateSearch: res.items })
        }
        else if (value === "") {

            this.setState({ [name]: value, usersList: [], select_user_id: "", user_list: this.state.user_list_search, allChecked: false, searchinList: "" })
        }
        else {
            this.setState({ [name]: value, usersList: [] })
        }
    }

    onSearch(e) {
        const value = e.target.value;
        this.setState({ searchinList: value })
        let user_list = []
        if (this.state.user_list_search) {
            user_list = _.filter(this.state.user_list_search, function (obj) {
                return obj.username.toLowerCase().indexOf(value.toLowerCase()) !== -1;
            });
            this.setState({ user_list: [] }, () => {
                this.setState({ user_list: user_list })
            });
        }
    }

    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }

    onChecked(username, value) {
        let userState = this.state.userState
        let lockUsersState = this.state.lockUsersState
        userState[username] = value
        lockUsersState[username] = value
        this.setState({ userState: userState, lockUsersState: lockUsersState })
    }

    onAllChecked(value) {
        if (value) {
            if (this.state.userStateSearch.length > 0) {
                let userState = {}
                let lockUsersState = {}
                userState[this.state.userStateSearch[0].username] = true
                lockUsersState[this.state.userStateSearch[0].username] = true
                this.setState({ allChecked: value, userState: userState, lockUsersState: lockUsersState })
            } else {
                let users = this.state.user_list
                let userState = {}
                let lockUsersState = {}
                for (let usr of users) {
                    userState[usr.username] = true
                    lockUsersState[usr.username] = true
                }
                this.setState({ allChecked: value, userState: userState, lockUsersState: lockUsersState })
            }
        }
        else {
            let lockUsersState = {}
            let lockUsers = this.state.lockUsers
            for (const lckusr of lockUsers) {
                lockUsersState[lckusr.username] = value
            }
            let userState = {}
            for (let usr of this.state.user_list) {
                userState[usr.username] = false
            }
            this.setState({ allChecked: value, lockUsersState: lockUsersState, userState: userState })
            // this.getUserMarketLock()
        }
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
    }

    onDownlineSearch(value) {
        if (value) {
            this.setState({ userStateSearch: [], usersList: [], select_user_id: "", user_id: "", user_list: this.state.user_list_search, allChecked: false, searchinList: "" })
        }
        this.setState({ downlineSearch: !value })
    }

    createLock(body) {
        gameControlService.addControl(body, this.state.mpassword).then((res) => {
            if (res.isSuccess) {
                this.getUserMarketLock()
            } else {
                this.props.notify(res.exception.message, "error")
                this.setState({ openPopup: true })
            }
        })
    }
    //Provider Lock
    eventMarketTypeLock(lock, un) {
        if (this.state.mpassword === "") {
            this.setState({ openPopup: true })
            this.props.notify(" Master Password is Required!", "error");
            return false
        }
        let body = {
            "controlType": "EMT",
            "eventId": this.props.event_id,
            "betLock": lock,
            "marketType": !!this.props.market.marketType ? this.props.market.marketType : this.props.market.mkt,
            "username": un
        }
        this.createLock(body)
    }

    render() {
        let userState = this.state.userState
        return (
            <>
                <div id="userbook" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                    {!this.state.openPopup && <div className="modal-dialog  modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">User Bet Lock - {!!this.props.market.marketName ? this.props.market.marketName : this.props.market.mkt.replaceAll("_", " ")}</h4>
                                <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closeMarketBetLock() }}>×</button>
                            </div>
                            <div className="modal-header betlocktransparent w-100 d-inline-block">
                                <div className="row w-100">
                                    <div className="col-5 col-sm-5 col-md-5 col-lg-5 mb-2">
                                        <span>
                                            <label className="checkboxx"><input type="checkbox" name="downlineSearch" checked={this.state.downlineSearch} onChange={() => { this.onDownlineSearch(this.state.downlineSearch) }} />
                                                <span className="checkmark1 font-12 betlocktop" ></span>
                                            </label>
                                        </span>
                                        <span className="text-black font-12 mr-1">Search Downline Client</span>
                                    </div>
                                    <div className="col-7 col-sm-7 col-md-7 col-lg-7">

                                        <div className="form-group font-12 autocomplete-wrapper mb-1">
                                            {!!this.state.downlineSearch &&
                                                <Autocomplete
                                                    value={this.state.user_id}
                                                    items={this.state.usersList}
                                                    getItemValue={item => item.title}
                                                    renderItem={(item, isHighlighted) =>
                                                        <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                                            {item.title}
                                                        </div>
                                                    }
                                                    inputProps={{ placeholder: 'Search by client' }}
                                                    name="user_id"
                                                    onChange={(event, user_id) => this.onUserSearch(event, "user_id", user_id)}
                                                    onSelect={user_id => this.setState({ select_user_id: user_id })}
                                                />
                                            }
                                        </div>

                                    </div>
                                </div>
                                <div className="row w-100 ">
                                    <div className="col-12">
                                        <input className="form-control w-100" name="searchinList" value={this.state.searchinList} onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body ac-state">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table id="example" className="table table-bordered table-sm font-14 nowrap">
                                                {/* <thead>
                                                    <tr>
                                                        <th>
                                                            <label className="checkboxx"><input type="checkbox" name="allChecked" checked={this.state.allChecked} onChange={() => { this.onAllChecked(!this.state.allChecked) }} /><span className="checkmark1"></span></label>
                                                        </th>
                                                        <th>All Account</th>
                                                    </tr>
                                                </thead> */}
                                                <tbody>
                                                    {!!this.state.select_user_id && this.state.userStateSearch.length > 0 ?
                                                        <tr>
                                                            <td>
                                                                <label className="checkboxx"><input type="checkbox" checked={userState[this.state.select_user_id]} onChange={() => { this.onChecked(this.state.select_user_id, !userState[this.state.select_user_id]) }} /><span className="checkmark1"></span></label>
                                                            </td>
                                                            <td><span className={this.state.userStateSearch[0].role === "SuperMaster" || this.state.userStateSearch[0].role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + this.state.userStateSearch[0].role + "-icon.svg"} alt="" /> {this.state.select_user_id}</span></td>
                                                        </tr>
                                                        : !!this.state.user_list && this.state.user_list.map((usr, i) => {
                                                            return (
                                                                <tr>
                                                                    <td>
                                                                        <label className="checkboxx"><input type="checkbox" checked={userState[usr.username]} onChange={() => { this.eventMarketTypeLock(!userState[usr.username], usr.username) }} /><span className="checkmark1"></span></label>
                                                                    </td>
                                                                    <td><span className={usr.role === "SuperMaster" || usr.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + usr.role + "-icon.svg"} alt="" /> {usr.username}</span></td>
                                                                </tr>
                                                            )
                                                        })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="modal-footer">
                                <div className="row w-100">
                                    <div className="col-6"><input type="Password" tabindex="12" name="master_password" className="form-control" placeholder="Master Password" value={this.state.master_password} onChange={(e) => { this.onChange(e) }} /></div>
                                    <div className="col-6"><button className="btn btn-blue accbtn mt-0" tabindex="13" onClick={() => { this.onUserMarketLock() }}>Submit </button></div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    }
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                    <div className="modal-backdrop fade show" onClick={() => { this.props.closeMarketBetLock() }}></div>
                </div>
                {this.state.openPopup && <MPModel closePopup={() => { this.setState({ openPopup: false }); this.props.closeMarketBetLock() }} setMasterPassword={(mp) => { this.setState({ mpassword: mp, openPopup: false }) }} />}
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MarketBetLock);